import {
  emptyFetch,
  KantarTrackingMetadata,
} from "@tv4/avod-web-player-common";

import { Tracker } from "./tracker";

export type IKantarTrackerInstanceOptions = KantarTrackingMetadata & {
  deviceId: string;
};

export class KantarTracking extends Tracker {
  private endpoint: string;
  private tracked: boolean = false;

  constructor({
    configuration: { endpoint },
    deviceId,
  }: IKantarTrackerInstanceOptions) {
    super();

    const url = new URL(endpoint);

    url.searchParams.set("fpid", deviceId);

    this.endpoint = url.toString();
  }

  public onStart(): void {
    this.track();
  }

  public onAdBreakStart(): void {
    this.track();
  }

  private track(): void {
    if (this.tracked) {
      return;
    }

    this.tracked = true;
    emptyFetch(this.endpoint, { mode: "no-cors" });
  }

  public destroy(): void {
    // noop
  }
}
